import { MmfVuexStoreHelper } from "../helpers/MmfVuexStoreHelper";
import { getField, updateField } from 'vuex-map-fields';

import { TIMEZONE, DATEFORMAT } from '@/model/constants'

var userPreferences = new MmfVuexStoreHelper({
    state: {
        id: null,
        language: "en",
        timezone: "D",
        dateFormat: "D",
        user: {
            id: null
        }
    },
    getters: {
        getField,
        getState(state) {
            return state
        },
        getLanguage(state) {
            return state.language
        },
        getTimezone(state) {
            return state.timezone
        },
        getDateFormat(state) {
            return state.dateFormat
        },
        getUser(state) {
            return state.user
        },
        getDateTimeString(state) {
            var timezoneFormat = ""
            var datetimeFormat = ""
            switch (state.timezone) {
                case TIMEZONE.DontShow:
                    timezoneFormat = ""
                    break;
                case TIMEZONE.DST:
                    //timezoneFormat = "ZZ"
                    break;
                case TIMEZONE.Show:
                    timezoneFormat = "ZZ"
                    break;
            }
            switch (state.dateFormat) {
                case DATEFORMAT.DayMonth:
                    datetimeFormat = "YYYY-MM-DD HH:mm:ss"
                    break;
                case DATEFORMAT.MonthDay:
                    datetimeFormat = "YYYY-MM-DD HH:mm:ss"
                    break;
            }
            return datetimeFormat + " " + timezoneFormat;
        }
    },
    actions: {
        setSession(context, payload) {
            var userName = payload.keycloak.tokenParsed.preferred_username;

            context.dispatch('api/get', { url: process.env.VUE_APP_ADM_API_URL + 'adm-service/adm/user/userPreferencesByName/' + userName }, { root: true })
                .then(json => {
                    context.commit('setSession', json)
                    payload.i18n.set(json.language)
                });

        },
    },
    mutations: {
        updateField,
        setSession(state, payload) {
            state.id = payload.id
            window.console.log(payload);
            window.console.log(payload.user.id);
            state.user.id = payload.user.id;
            state.language = payload.language;
            state.timezone = payload.timezone;
            state.dateFormat = payload.dateFormat;
        }
    }
}).namespaced()


export default userPreferences.buildStore()